// © Microsoft Corporation. All rights reserved.

import { ActionMap } from "@msnews/experiences-redux";
import { CookieConsentStatus as CookieConsentStatusInfo } from "@msnews/experiences-constants";
import { SignedInStatus as SignedInStatusInfo } from "@msnews/experiences-constants";
import { OneTrustCookieCategory } from "@msnews/cookie-consent-common";

type SignedInStatus = (signedIn: SignedInStatusInfo) => boolean;
type CookieConsentStatus = (consentStatus: CookieConsentStatusInfo) => void;
type OneTrustActiveCookieCategories = (activeCategories: Array<OneTrustCookieCategory>) => void;
type UseEnterpriseCompliance = (useEnterpriseCompliance: boolean) => void;
type UseEnterpriseDomain = (useEnterpriseDomain: boolean) => void;
type UseHistory = (useHistory: boolean) => void;

/**
 * Class containing actions that apply to the ExperiencesSharedState connector
 * @class
 */
export class ExperiencesSharedStateActions {
    /**
     * Action for signed-in status state update
     */
    public static signedInStatus: ActionMap<SignedInStatus> = new ActionMap<SignedInStatus>("SignedInStatus");

    /**
     * Action for cookie consent status state update
     */
    public static cookieConsentStatus: ActionMap<CookieConsentStatus> = new ActionMap<CookieConsentStatus>("CookieConsentStatus");

    /**
     * Action for useEnterpriseCompliance state update
     */
    public static oneTrustActiveCookieCategories: ActionMap<OneTrustActiveCookieCategories> = new ActionMap<OneTrustActiveCookieCategories>("OneTrustActiveCookieCategories");

    /**
     * Action for useEnterpriseCompliance state update
     */
    public static useEnterpriseCompliance: ActionMap<UseEnterpriseCompliance> = new ActionMap<UseEnterpriseCompliance>("UseEnterpriseCompliance");

    /**
     * Action for useEnterpriseDomain state update
     */
    public static useEnterpriseDomain: ActionMap<UseEnterpriseDomain> = new ActionMap<UseEnterpriseDomain>("UseEnterpriseDomain");

    /**
     * Action for useHistory state update
     */
    public static useHistory: ActionMap<UseHistory> = new ActionMap<UseHistory>("UseHistory");
}
